<template>
	<div class="panel_shouyin">
		<div>
			<!-- <div class="titleLine">
				<el-row>
					<el-col :span="6">
						待受理计划
					</el-col>
				</el-row>
			</div> -->
			<div>
				<el-table :data="planList" style="width: 100%">
					<el-table-column prop="distribution_no" label="分拨批次号">
						<template slot-scope="scope">
							<span style="color:#1890FF;cursor: pointer;" @click="toYanshou(scope.row.distribution_no)">{{scope.row.distribution_no}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="create_time" label="采购分拨日期">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.create_time)}}
						</template>
					</el-table-column>
					
					<el-table-column prop="name" label="分拨人">
						<template slot-scope="scope">
							{{scope.row.add_user.user_name}}
						</template>
					</el-table-column>
					<el-table-column prop="name" label="状态">
						<template slot-scope="scope">
							<span v-if="scope.row.state==1" style="color: #2A2A2A ;">已收货</span>
							<span v-if="scope.row.state==2" style="color: #FFAE11;">部分收货</span>
							<span v-if="scope.row.state==3" style="color: #FF182A;">未收货</span>
				
						</template>
					</el-table-column>
					<!-- <el-table-column prop="name" label="收货人" width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.received_goods&&scope.row.received_goods.length>0">
								{{scope.row.received_goods[scope.row.received_goods.length -1].success_user_info.user_name}}</span>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="name" label="收货日期">
						<template slot-scope="scope">
							<span v-if="scope.row.received_goods&&scope.row.received_goods.length>0">
								{{$public.FTime(scope.row.received_goods[scope.row.received_goods.length -1].received_time)}}</span>
						</template>
					</el-table-column> -->
					<el-table-column prop="name" label="阅读状态">
						<template slot-scope="scope">
							<span v-if="scope.row.is_read == 0">
								未读
							</span>
							<span v-if="scope.row.is_read == 1">
								已读
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="remarks" label="收货备注">
						<template slot-scope="scope">
						<span class="remark">{{scope.row.remarks}}
						</span>
						<el-popover v-if="scope.row.remarks" placement="top-start"  width="200" trigger="hover" :content="scope.row.remarks">
							<el-button slot="reference" type="text" icon="el-icon-view"></el-button>
						</el-popover>
						</template>
					</el-table-column>
					<!-- <el-table-column label="操作">
						<template slot-scope="scope">
							<el-button v-if="scope.row.state!=1" icon="el-icon-edit" type="text" @click='inspectionEdit(scope.row.distribution_no)'>验货</el-button>
							<el-button icon="el-icon-view" type="text" @click='inspectionLook(scope.row.distribution_no)'>查看</el-button>
						</template>
					</el-table-column> -->
				</el-table>
				<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
			</div>
		</div>
		<activitySee v-if="drawerActivitySee_state" :curItem="curItem" @submit="submit_drawerActivitySee"></activitySee>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import activitySee from "../drawer/activitySee.vue"
	export default {
		components:{page,activitySee},
		data(){
			return{
				planList:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// see
				drawerActivitySee_state:false,
				curItem:{}
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getPlanList();
		},
		methods: {
			see(row){
				this.curItem=row;
				this.drawerActivitySee_state = true;
			},
			submit_drawerActivitySee(){
				this.drawerActivitySee_state = false;
			},
			// 改变分页
			changePage(a){
				this.page.page=a;
				this.getPlanList();
			},
			// 获取表格数据
			getPlanList() {
				let loading=this.$loading();
				let params = {
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				this.$http.get('/api/Platform/ProcureList', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.planList = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			toYanshou(id){
				this.$router.push({path: '/caigouMendian/inspectionEdit',query: {id,'refer':"mendianshouyin"}})
			}
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	background-color: #fff;height: 100%;padding:0 0 20px;box-sizing: border-box;
	// .titleLine{
	// 	width:100%;
	// 	background-color: #fff;
	// 	height: 44px;
	// 	line-height: 30px;
	// 	padding:8px 8px;
	// 	box-sizing: border-box;
	// 	margin-bottom: 4px;
	// }
}
</style>
